import { useState } from "react";
import { Search } from "lucide-react";
import { toast } from "sonner";
import { API, inr, fmtErr } from "../lib/api";
import { Timeline } from "./OrderSuccess";

export default function TrackOrder() {
  const [orderNumber, setOrderNumber] = useState("");
  const [email, setEmail] = useState("");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);

  const track = async (e) => {
    e.preventDefault();
    setLoading(true);
    setOrder(null);
    try {
      const r = await API.get(`/orders/track/${encodeURIComponent(orderNumber.trim())}`, { params: { email } });
      setOrder(r.data);
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-ink border border-[#262626] px-4 py-3 text-sm outline-none focus:border-gold transition-colors";

  return (
    <div className="max-w-2xl mx-auto px-4 py-20" data-testid="track-order-page">
      <p className="text-xs uppercase tracking-[0.3em] text-gold font-bold mb-2">Where's my fit?</p>
      <h1 className="font-display font-black text-4xl tracking-tighter mb-8">Track your order</h1>
      <form onSubmit={track} className="border border-[#262626] bg-ink-surface p-6 space-y-4">
        <input data-testid="track-order-number" value={orderNumber} onChange={(e) => setOrderNumber(e.target.value)}
          placeholder="Order number (e.g. DN-100001)" required className={inputCls} />
        <input data-testid="track-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="Email used at checkout" required className={inputCls} />
        <button data-testid="track-submit-btn" disabled={loading}
          className="btn-gold w-full py-3.5 font-display font-bold text-sm uppercase tracking-[0.2em] flex items-center justify-center gap-2 disabled:opacity-50">
          <Search size={15} /> {loading ? "Tracking..." : "Track order"}
        </button>
      </form>

      {order && (
        <div className="border border-[#262626] bg-ink-surface p-6 mt-8" data-testid="track-result">
          <div className="flex items-center justify-between flex-wrap gap-2">
            <div>
              <p className="font-display font-bold text-lg">{order.order_number}</p>
              <p className="text-xs text-muted-foreground">Placed {order.created_at.slice(0, 10)}</p>
            </div>
            <p className="text-gold font-bold">{inr(order.total)}</p>
          </div>
          <div className="mt-6"><Timeline status={order.status} timeline={order.timeline} /></div>
          <div className="mt-6 space-y-2 text-sm">
            {order.items.map((i) => (
              <p key={i.sku + i.size} className="text-muted-foreground">{i.name} — {i.size}/{i.color} × {i.qty}</p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
